import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlideWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"slide-wide-add"} maskId="square-filled-radius-0-stroke-1-IconSlideWideAdd"><path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM12.5 8H11.5V11.5H8V12.5H11.5V16H12.5V12.5L16 12.5V11.5H12.5V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSlideWideAdd;
